export function logoutToLogin(logout: () => void, navigate: (path: string) => void) {
  logout();
  navigate("/login");
}
